import { CELL_TYPES } from "../../../shared/Table";
import {
  TableCellAccountRedirect,
  TableCellPayoutData,
} from "../../../shared/Table/components/Cell";

/// OLD COMPONENTS
import {
  financingStages,
  financingRatings,
  financingAssetTypes,
  financingAssetClasses,
} from "admin/shared/dictionary/enums";

import TableCellFinancingActions from "./Table/TableCellFinancingActions";
import TableCellPayoutActions from "./Table/TableCellPayoutActions";

export function getFinancingColumns(
  getFinancingPayoutInfo,
  registerPayout,
  closeFinancing,
  openFinancing,
  unPublishFinancing,
  publishFinancing,
  cancelFinancing,
  isMPL,
) {
  let list = [
    { key: "IntId", label: "Id", type: CELL_TYPES.text, visible: true },
    {
      key: "ExternalId",
      label: "Loanstep Id",
      type: CELL_TYPES.number,
      visible: false,
    },
    {
      key: "Stage",
      label: "Stage",
      type: CELL_TYPES.enum,
      visible: true,
      enumDict: financingStages,
    },
    {
      key: "OriginatorName",
      label: "Originator Name",
      type: CELL_TYPES.text,
      visible: true,
    },
    {
      key: "AssetType",
      label: "Asset type",
      visible: true,
      type: CELL_TYPES.enum,
      enumDict: financingAssetTypes,
    },
    {
      key: "AssetClass",
      label: "Asset class",
      visible: true,
      type: CELL_TYPES.enum,
      enumDict: financingAssetClasses,
    },
    { key: "LoanTerm", label: "Loan Term", visible: true },
    {
      key: "LoanAmount.Amount",
      label: "Loan Amount",
      visible: true,
      type: CELL_TYPES.money,
    },
    {
      key: "PublishedAt",
      label: "Published At",
      visible: false,
      type: CELL_TYPES.date,
    },
    {
      key: "AvailableToBook.Amount",
      label: "Available To Invest",
      visible: true,
      type: CELL_TYPES.money,
    },
    {
      key: "AmountFunded.Amount",
      label: "Invested Amount",
      visible: true,
      type: CELL_TYPES.money,
    },
    {
      key: "action",
      label: "Actions",
      filter: false,
      visible: true,
      renderer: (value, item) => {
        return (
          <TableCellFinancingActions
            closeFinancing={closeFinancing}
            openFinancing={openFinancing}
            cancelFinancing={cancelFinancing}
            unPublishFinancing={unPublishFinancing}
            publishFinancing={publishFinancing}
            value={value}
            item={item}
          />
        );
      },
    },
  ];

  let country = {
    key: "Originator",
    label: "Originator",
    visible: true,
    type: CELL_TYPES.text,
  };
  let originator = {
    key: "Country",
    label: "Country",
    visible: true,
    type: CELL_TYPES.text,
  };
  if (isMPL) list.splice(7, 1, country, originator);

  return list;
}

export function getFinancingIssuedColumns(
  getFinancingPayoutInfo,
  registerPayout,
  getPayoutInfo,
  cancelLoan,
) {
  return [
    { key: "Id", label: "Id", visible: false, type: CELL_TYPES.number },
    {
      key: "payout",
      label: "SSN",
      visible: true,
      renderer: (value) => {
        return <TableCellPayoutData prop="ssn" value={value} />;
      },
    },
    ///IssueDate
    {
      key: "payout",
      label: "Account",
      visible: true,
      renderer: (value) => {
        return <TableCellPayoutData prop="bankNumber" value={value} />;
      },
    },
    {
      key: "payout",
      label: "Bank",
      visible: true,
      renderer: (value) => {
        return <TableCellPayoutData prop="bankName" value={value} />;
      },
    },
    {
      key: "payout",
      label: "Sum",
      visible: true,
      renderer: (value) => {
        return <TableCellPayoutData prop="sum" value={value} />;
      },
    },
    {
      key: "PayoutAmount.Amount",
      label: "Borrower",
      visible: true,
      type: CELL_TYPES.money,
    },
    {
      key: "payout",
      label: "Savelend",
      visible: true,
      renderer: (value) => {
        return <TableCellPayoutData prop="fee" value={value} />;
      },
    },

    {
      key: "AccountId",
      label: "Account Id",
      visible: false,
      type: CELL_TYPES.text,
      renderer: (value) => {
        return <TableCellAccountRedirect value={value} type={"accountId"} />;
      },
    },
    { key: "Archived", label: "Archived", visible: false },
    {
      key: "Stage",
      label: "Stage",
      visible: false,
      enumDict: financingStages,
      type: CELL_TYPES.enum,
    },
    {
      key: "Rating",
      label: "Rating",
      visible: false,
      enumDict: financingRatings,
      type: CELL_TYPES.enum,
    },
    {
      key: "MinimumFundingReached",
      label: "Minimum Funding Reached",
      visible: false,
    },
    {
      key: "AssetType",
      label: "Asset type",
      visible: false,
      enumDict: financingAssetTypes,
      type: CELL_TYPES.enum,
    },
    {
      key: "AssetClass",
      label: "Asset class",
      visible: false,
      enumDict: financingAssetClasses,
      type: CELL_TYPES.enum,
    },
    { key: "LoanTerm", label: "Loan Term", visible: false },
    { key: "LoanOffer", label: "Loan Offer", visible: false },
    {
      key: "EndDate",
      label: "End Date",
      visible: false,
      type: CELL_TYPES.date,
    },
    {
      key: "PublishedAt",
      label: "Published At",
      visible: false,
      type: CELL_TYPES.date,
    },
    {
      key: "ClosedAt",
      label: "Closed At",
      visible: false,
      type: CELL_TYPES.date,
    },
    {
      key: "AvailableToBook.Amount",
      label: "Available To Book",
      visible: false,
      type: CELL_TYPES.money,
    },
    {
      key: "AmountFunded.Amount",
      label: "Amount Funded",
      visible: false,
      type: CELL_TYPES.money,
    },
    {
      key: "Id",
      label: "Actions",
      visible: true,
      renderer: (value, item) => {
        return (
          <TableCellPayoutActions
            getFinancingPayoutInfo={getFinancingPayoutInfo}
            getPayoutInfo={getPayoutInfo}
            registerPayout={registerPayout}
            cancelLoan={cancelLoan}
            value={value}
            item={item}
          />
        );
      },
    },
  ];
}
